import { getCreatorDefsites } from './divideDefsitesByOrigin.js';

export const getPathToTypeList = () => getCreatorDefsites().map((site, index, arr) => ({
    path: site.creatorPath,
    type: site.listName.slice(0, -4),
    pageTranslationKey: site.pageTranslationKey,
    index: index,
    listName: site.listName,
    prevPagePath: index > 0 ? arr[index - 1].creatorPath : null,
    nextPagePath: index < (arr.length - 1) ? arr[index + 1].creatorPath : null
}))




// WEBPACK FOOTER //
// ./src/utils/listBodyUtils.js